import { create } from "zustand";

// Yeni temaları tip tanımına ekledik
type Theme = "light" | "dark" | "ocean" | "purple" | "midnight" | "emerald" | "rose" | "slate";

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

function applyTheme(theme: Theme) {
  const html = document.documentElement;

  // Mevcut tüm tema sınıflarını listeye ekleyerek temizliyoruz
  const themes: Theme[] = ["light", "dark", "ocean", "purple", "midnight", "emerald", "rose", "slate"];
  themes.forEach((t) => html.classList.remove(t));

  // Yeni temayı ekliyoruz
  html.classList.add(theme);
  
  // Electron tarafına veya diğer sistemlere haber vermek istersen burayı kullanabilirsin
  // document.body.style.backgroundColor = 'var(--bg)';
}

export const useThemeStore = create<ThemeState>((set) => {
  // Başlangıçta localStorage'dan oku, yoksa 'light' ata
  const saved = typeof window !== "undefined"
    ? (localStorage.getItem("theme") as Theme) || "light"
    : "light";

  // İlk açılışta temayı uygula
  applyTheme(saved);

  return {
    theme: saved,
    setTheme: (theme) => {
      localStorage.setItem("theme", theme);
      applyTheme(theme);
      set({ theme });
    },
  };
});